import React, { useEffect, useState } from 'react';
import { Grid, Typography } from '@mui/material';
import { useStyles } from './Style';
import { TableComponents, SimpleDialog } from 'components';
import { useCommon, useCommonDispatcher, useQuery } from 'hooks';
import persianJs from 'persianjs';
import jMoment from 'moment-jalaali';
import ActivityLogServices from './services/ActivityLogServices';
import { columns } from './components/Columns';
import axios from 'axios';

const Content = () => {

  const setDialog = useCommonDispatcher();
  const [, setQueryFilter] = useState({});
  const [size, setSize] = useState(10);
  const [page, setPage] = useState(0);
  const [loading, setLoading] = useState(false);
  const dialog = useCommon();
  const query = useQuery();
  const classes = useStyles();

  useEffect(() => {
    const q = query.get('guildName');
    if (q) {
      setQueryFilter({ guildName: q });
    }
  }, []);


  const enifyDateTimeFilter = (date, time) => {
    const d = persianJs(date).toEnglishNumber().toString();
    const t = persianJs(time).toEnglishNumber().toString();

    const res = jMoment(`${d} ${t}`, 'jYYYY/jM/jD HH:mm:ss').valueOf(); // milisec

    return res; // sec
  };

  const getList = async (query) => {
    setLoading(true)

    try {
      let params = {
        offset: query ? query?.pageNumber * query?.pageSize : page * size,
        size: query ? query?.pageSize : size,
      };

      const otherParams = {};
      if (query?.filters) {
        query?.filters.map((v) => {
          if (v?.column?.field) {
            if (v?.column?.field == 'time') {
              const fromTime = enifyDateTimeFilter(
                v?.value?.startDateTime?.date,
                v?.value?.startDateTime?.time,
              );
              const toTime = enifyDateTimeFilter(
                v?.value?.endDateTime?.date,
                v?.value?.endDateTime?.time,
              );

              if (fromTime) otherParams.fromTime = fromTime;
              if (toTime) otherParams.toTime = toTime;
            } else {
              otherParams[v?.column?.field] = v?.value;
            }
          }
        });
      }

      params = { ...otherParams, ...params };

      if (query?.orderBy) {
        params.orderBy =
          query?.orderDirection == 'desc' ? `${query?.orderBy?.field}:desc` : query?.orderBy?.field;
      }

      const r = await ActivityLogServices.getActivityLog(params);
      setLoading(false)

      return {
        data: r?.result?.reports,
        page: query ? query?.pageNumber : page,
        totalCount: r?.result?.total,
      };
    } catch (error) {
      if (axios.isCancel(error)) {
        setLoading(true);
      } else {
        setLoading(false);
        return {
          data: [],
          page: query ? query?.pageNumber : page,
          totalCount: 0,
        };
      }
      
    }
  };

  const handleCloseDialog = () => {
    setDialog({ title: '', content: '', open: false });
  };

  const hint = 'در این بخش شما می‌توانید گزارش فعالیت خود در پنل کاربری را مشاهده نمایید.';
  return (
    <>
      <Typography className={classes.hint}>{hint}</Typography>

      <Grid container spacing={4}>
        <Grid item xs={12}>
          <TableComponents
            columns={columns}
            data={getList}
            isLoading={loading}
            onChange={(ps) => {
              setPage(ps?.pageNumber)
              setSize(ps?.pageSize)
              return getList(ps)
            }}
        
          />
        </Grid>
      </Grid>
      <SimpleDialog
        fullWidth
        maxWidth="lg"
        open={dialog?.open || false}
        title={dialog?.title}
        onClose={handleCloseDialog}
        loading={dialog?.loading || false}
      >
        {dialog?.content}
      </SimpleDialog>
    </>
  );
};


export default Content;
